import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { SuiToggle } from '@splashthat/sui';
import { getFormNodeIsRequired, getFormNodeGroupIsRequired } from 'common/entities/formLogicRule/selectors';
import { getFormNode } from 'common/entities/formNode/selectors';
import { NODE_TYPE_GROUP } from 'common/entities/formNode/nodeTypes';
import { setRequiredFormNodeLogic } from 'common/compounds/FormBuilder/actions/logicActions';
import { colorAppShadedBackground } from 'common/styles/colors';

import EditViewSectionContainer from '../EditViewSectionContainer';
import disableWhenLocked from './disableWhenLocked';
import { getEditFormNodeId } from '../../../selectors';

const REQUIRED = 'Required';

const RequiredControlContainer = styled.div`
    background-color: ${colorAppShadedBackground};
`;

/**
 * The view to make questions required or not.
 */
const RequiredControl = ({ required, onChange, disabled, formNodeId }) => (
    <RequiredControlContainer>
        <EditViewSectionContainer>
            <SuiToggle
                label={REQUIRED}
                enabled={required}
                onChange={(event, value) => onChange(formNodeId, value)}
                disabled={disabled}
                data-qa={`${REQUIRED}__question-toggle`}
            />
        </EditViewSectionContainer>
    </RequiredControlContainer>
);

RequiredControl.propTypes = {
    required: PropTypes.bool.isRequired,
    formNodeId: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    /** disabled is passed when form node editing is locked */
    disabled: PropTypes.bool.isRequired,
};

// -------------------
// Connected component

const mapStateToProps = (state) => {
    const formNodeId = getEditFormNodeId(state);
    const formNode = getFormNode(state, formNodeId);

    const required =
        formNodeId && formNode.type === NODE_TYPE_GROUP
            ? getFormNodeGroupIsRequired(state, formNode)
            : getFormNodeIsRequired(state, formNode.formId, formNodeId);

    return {
        formNodeId,
        required,
    };
};

const mapDispatchToProps = (dispatch) => ({
    onChange: (formNodeId, required) => dispatch(setRequiredFormNodeLogic(formNodeId, required)),
});

const ConnectedRequiredControl = connect(mapStateToProps, mapDispatchToProps)(disableWhenLocked(RequiredControl));

ConnectedRequiredControl.propTypes = {
    formNodeId: PropTypes.string,
};
ConnectedRequiredControl.defaultProps = {
    formNodeId: undefined,
};

export default ConnectedRequiredControl;
